import React from "react";
import styled from "styled-components";

const HabitAnalysis = ({ habits = [] }) => {
  // Helper function to calculate the completion rate for each habit
  const calculateCompletionRate = (habit) => {
    const { completedDates = {}, startDate } = habit;
    if (!startDate) return 0;

    const start = new Date(startDate);
    const today = new Date();
    const totalDays = Math.ceil((today - start) / (1000 * 60 * 60 * 24)); // Total days since the start date

    const completedCount = Object.keys(completedDates).length; // Number of completed days
    const completionRate =
      totalDays > 0 ? ((completedCount / totalDays) * 100).toFixed(2) : 0;

    return completionRate;
  };

  // Prepare habits with completion rates
  const analyzedHabits = habits.map((habit) => ({
    ...habit,
    completionRate: calculateCompletionRate(habit),
  }));

  return (
    <AnalysisContainer>
      <h3>Habit Completion Rates</h3>
      {analyzedHabits.length === 0 ? (
        <p>No habits to analyze!</p>
      ) : (
        <div className="habits-list">
          {analyzedHabits.map((habit) => (
            <div key={habit.id} className="habit-card">
              <h4>{habit.name}</h4>
              <p>
                Completion Rate: <strong>{habit.completionRate}%</strong>
              </p>
            </div>
          ))}
        </div>
      )}
    </AnalysisContainer>
  );
};

// Styled container
const AnalysisContainer = styled.div`
  margin-top: 2em;
  padding: 20px;
  background: #1f2637;
  border-radius: 15px;
  color: white;

  h3 {
    text-align: center;
    font-weight: 300;
    margin-bottom: 20px;
  }

  .habits-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
  }

  .habit-card {
    background: #2a344b;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 250px;
    text-align: center;

    h4 {
      font-size: 1.2em;
      margin-bottom: 10px;
    }

    p {
      font-size: 1em;
      margin: 0;
    }

    strong {
      color: #5ac18e;
    }
  }
`;

export default HabitAnalysis;
